export function DocumentsSearchField({ searchQuery, setSearchQuery }) {
  return (
    <div className="relative">
      <input
        type="text"
        data-testid="documents-search-input"
        value={searchQuery}
        onChange={(event) => setSearchQuery(event.target.value)}
        placeholder="Rechercher un document..."
        className="h-12 w-full rounded-sm border border-zinc-800 bg-zinc-900/50 pl-12 pr-4 text-white placeholder:text-zinc-600 focus:border-white focus:outline-none focus:ring-0"
      />
    </div>
  );
}
